import {Feature, FeatureLayerInfo} from '../../core/models'
import {XyParser} from '../../core/services/crud/XyParser'
import appConfig from '../../reducers/appConfig'

export class AppXyParser extends XyParser {
  protected setGeometry(d: any, layerInfo: FeatureLayerInfo, feature: Feature) {
    if (layerInfo.sourceDescription.id == appConfig.reg.siteLine.id) {
      if (!d['LineType'] || d['LineType'] > 3) {
        d['LineType'] = '3'
      }
    }
    super.setGeometry(d, layerInfo, feature)
  }
}
